import React from 'react'
import './TopNavbar.css'
import { AiOutlineWhatsApp } from 'react-icons/ai';
import { AiOutlineMail } from 'react-icons/ai';


const TopNavbar = () => {
  return (
    <>
    <div className='mainTopNavbar'>
        <div className='mainTopNavbarInner'>
        <div className='topCardContact'>
            <AiOutlineWhatsApp/>
            <div>+447832576287</div>
            
        </div>
        <div className='topCardContact'>
            <AiOutlineMail/>
            <div>info@Karlinetransfers.com</div>
            
        </div>

        </div>

    </div>
    
    </>
  )
}

export default TopNavbar